module.exports = __webpack_public_path__ + "static/joanna-kosinska-7ACuHoezUYk-unsplash 2-4f2847dec10befc52b780054c95aa403.png";